import { render, staticRenderFns } from "./FormTemplateList.vue?vue&type=template&id=6c6a6a12&"
import script from "./FormTemplateList.vue?vue&type=script&lang=js&"
export * from "./FormTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports